import { GridStack } from "gridstack";
import DMSHeader from "../DMSHeader/DMSHeader";

import GridItem from "../../../Components/UiComponents/GridItem/GridItem";
import { useEffect } from "react";
import GeofenceManagement from "./GeofenceManagement";






// Component for rendering ATM table details
const GeofenceManage = () => {
  // Initialize GridStack layout system on component mount
  useEffect(() => {
    GridStack.init();
  }, []);

  // Define grid layout configuration with header and form components
  const layoutData = [
    {
      x: 0,
      y: 0,
      width: 12,
      height: 1,
      id: 0,
      component: (
        <DMSHeader
          title="Geofencing Details"
          showdownload={false}
          fileName="Geofence Details"
          showIconsForback={false}
        />
      ),
      haveOverflowVisible: true,
    },
    {
      x: 0,
      y: 1,
      width: 12,
      height: 13,
      id: 1,
      component: <GeofenceManagement />,
    },
  ];

  // Render grid container with layout items
  return (
    <div className="grid-stack grid-stack-instance-1 smartpole__header--transition ">
      <GridItem layoutData={layoutData} />
    </div>
  );
};

export default GeofenceManage;
